import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { RENDERABLE } from '../Utils/propTypes';
import './style.scss';

const ContentWrapper = ({ children, preventCloseAction, isOpen, className }) => {

    if (!isOpen) {
        return null;
    }

    const classes = classNames('modal-want-to-leave', className);

    return (
        <div className={classes} ref={preventCloseAction}>
            {children}
        </div>
    );
};

ContentWrapper.propTypes = {
    children: RENDERABLE.isRequired,
    isOpen: PropTypes.bool,
    preventCloseAction: PropTypes.func,
    className: PropTypes.string
};

ContentWrapper.defaultProps = {
    isOpen: false,
    preventCloseAction: () => null,
    className: ''
};

export default ContentWrapper;
